const getPath = (id) => {
  switch (id) {
    case "plus":
      return "M25 0c13,0 24,11 24,25 0,13 -11,24 -24,24 -14,0 -25,-11 -25,-24 0,-14 11,-25 25,-25zm-3 13l5 0 0 9 9 0 0 5 -9 0 0 9 -5 0 0 -9 -9 0 0 -5 9 0 0 -9z";
    case 2:
      return "M25 15c0,0 0,0 0,0 0,0 0,0 0,0 0,0 -1,0 -1,0 0,0 0,0 0,0l0 0c-5,0 -7,4 -9,8 -1,2 -3,3 -5,4 -4,3 -5,11 -2,14 4,4 12,0 17,0 5,0 12,4 16,0 3,-3 2,-11 -2,-14 -2,-1 -4,-2 -5,-4 -2,-4 -4,-8 -9,-8l0 0zm24 2c0,-4 -2,-7 -6,-7 -3,0 -5,3 -5,7 0,4 2,8 5,8 4,0 6,-4 6,-8zm-11 -10c0,-4 -3,-7 -6,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 6,-4 6,-8zm-15 0c0,-4 -3,-7 -6,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 6,-4 6,-8zm-12 10c0,-4 -2,-7 -5,-7 -3,0 -6,3 -6,7 0,4 3,8 6,8 3,0 5,-4 5,-8z";
    case 3:
      return "M25 45l-1 0c-6,-4 -12,-8 -17,-13 -5,-6 -7,-12 -7,-19 0,-7 6,-13 13,-13 6,0 10,3 12,6 2,-3 5,-6 11,-6 7,0 13,6 13,13 0,7 -2,13 -7,19 -5,5 -11,9 -16,13l-1 0z";
    case 4:
      return "M5 9l8 0 0 -2c0,-4 3,-7 7,-7l0 0c4,0 7,3 7,7l0 2 7 0c3,0 6,3 6,6l0 7 2 0c4,0 7,3 7,7l0 0c0,4 -3,7 -7,7l-2 0 0 8c0,3 -3,5 -6,5l-9 0 0 -4c0,-2 -3,-4 -5,-4l0 0c-3,0 -5,2 -5,4l0 4 -10 0c-3,0 -5,-2 -5,-5l0 -10 4 0c3,0 5,-2 5,-5l0 0c0,-2 -2,-4 -5,-4l-4 0 0 -10c0,-3 2,-6 5,-6z";
    case 5:
      return "M13 0c3,0 6,0 9,0l0 5c5,1 9,6 9,12l0 7 4 5 0 5c-13,0 -22,0 -35,0l0 -5 4 -5 0 -7c0,-6 4,-11 9,-12l0 -5zm11 37c-1,3 -4,4 -6,4 -3,0 -6,-1 -7,-4l13 0z";
    case 6:
      return "M49 17c0,-3 -4,-8 -10,-11 -2,3 -3,7 -3,11 0,4 1,8 3,10 6,-2 10,-7 10,-10l0 0zm-9 -4c1,0 2,1 2,2 0,1 -1,2 -2,2 -1,0 -2,-1 -2,-2 0,-1 1,-2 2,-2zm-5 -8c-1,0 -3,0 -4,0 -2,-3 -9,-6 -11,-5 1,3 1,4 1,6 -3,1 -6,4 -10,6 -2,-2 -7,-5 -11,-4 0,4 2,8 3,9 -1,1 -3,5 -3,9 4,0 9,-2 11,-5 4,3 7,6 10,7 0,1 0,3 -1,5 2,1 9,-2 11,-4 1,0 3,0 4,-1 -2,-3 -3,-7 -3,-11 0,-5 1,-9 3,-12z";
    case 7:
      return "M49 42c-4,-1 -7,-3 -9,-5 1,-4 2,-8 1,-11 -1,-5 -5,-9 -9,-12 -5,-3 -9,-4 -13,-5 -2,0 -4,0 -7,-1 -4,-1 -9,-6 -9,-6l-3 -2 0 4c0,0 0,6 2,15 1,10 5,17 10,21 4,4 9,6 14,6 5,-1 9,-3 11,-6 3,2 6,4 10,5 1,-1 2,-2 2,-3zm-13 -7c-6,-10 -19,-16 -29,-24 11,13 22,14 29,24z";
    case 8:
      return "M48 1c-3,-2 -24,-2 -36,25l11 11c28,-12 27,-33 26,-36 0,0 0,0 -1,0zm-30 9c-1,1 -9,12 -9,14 -3,0 -9,-3 -9,-3 7,-7 9,-10 12,-11 1,-1 4,-1 6,0zm22 21c-2,1 -13,9 -15,9 0,3 3,9 3,9 7,-7 10,-9 12,-11 1,-2 0,-4 0,-7zm-35 3c3,-3 7,-3 10,0 3,3 3,8 0,10 -3,3 -11,5 -15,5 0,-4 2,-12 5,-15zm32 -21c2,2 2,5 0,7 -3,2 -6,2 -8,0 -2,-2 -2,-5 0,-7 2,-2 5,-2 8,0z";
    default:
      return false;
  }
};

export const GroupIcon = ({
  id,
  type = null,
  fill = "#fff",
  stroke = "yellow",
  strokeWidth = 0,
  style = {},
  onClick,
}) => {
  return (
    <svg
      id={id}
      style={style}
      onClick={onClick}
      width="4.5179mm"
      height="4.2968mm"
      viewBox="0 0 49 49"
    >
      {id === 1 && !type ? (
        <polygon
          fill={fill}
          stroke={stroke}
          strokeWidth={strokeWidth}
          points="25,0 31,18 49,18 34,29 40,47 24,36 9,47 15,29 0,18 19,18 "
        />
      ) : !id ? (
        <>
          <circle
            fill={fill === "gray" ? "#a7a7a7" : "yellow"}
            cx="25"
            cy="25"
            r="24"
          />
          <circle
            fill={fill === "gray" ? "gray" : "red"}
            cx="25"
            cy="25"
            r="18"
          />
        </>
      ) : (
        <path
          id={id}
          fill={fill}
          fillRule="evenodd"
          stroke={stroke}
          strokeWidth={strokeWidth}
          d={getPath(type ?? id)}
        />
      )}
    </svg>
  );
};
